module.exports = __webpack_public_path__ + "static/media/pricing.1b8eb39d.svg";